import { render } from "./SkipperRegistration.vue?vue&type=template&id=95d5fa70&scoped=true"
import script from "./SkipperRegistration.vue?vue&type=script&lang=js"
export * from "./SkipperRegistration.vue?vue&type=script&lang=js"

import "./SkipperRegistration.vue?vue&type=style&index=0&id=95d5fa70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95d5fa70"

export default script